module.exports = __webpack_public_path__ + "static/img/img25.db3b87a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img25.png
// module id = YV3G
// module chunks = 1